import React from "react";

import { PinIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import { Tooltip } from "ds/Tooltip";

import * as S from "./TimeframeSelector.styles";

export type TabSyncProps = {
  isSynced?: boolean;
  canJoinSync?: boolean;
  onSyncChange?: (isSynced: boolean) => void;
  enabled?: boolean;
};

const tabSyncMessage = {
  unpin: "metrics_sync_unpin_tab",
  add: "metrics_sync_join_tab",
  pin: "metrics_sync_across_tab"
} as const;

const SyncTab = (props: TabSyncProps) => {
  const { isSynced, canJoinSync, onSyncChange, enabled } = props;

  const intl = useIntl();
  const syncStatus = isSynced ? "unpin" : canJoinSync ? "add" : "pin";

  const syncIsActive = syncStatus === "unpin" || syncStatus === "add";
  const tabSyncEnabled = enabled && "BroadcastChannel" in window;

  const tabSyncMessageId = tabSyncMessage[syncStatus];

  return tabSyncEnabled ? (
    <>
      <S.Divider />
      <Tooltip
        align="end"
        pointerPosition="fromRight=2px"
        tooltip={intl.formatMessage({ id: tabSyncMessageId })}
      >
        <S.PinIconContainer
          isActive={syncIsActive}
          onClick={() => onSyncChange?.(!isSynced)}
        >
          <PinIcon fill="none" status={syncStatus} />
        </S.PinIconContainer>
      </Tooltip>
    </>
  ) : null;
};

export default SyncTab;
